module.exports = __webpack_public_path__ + "img/playbooks-widget.6134d7fb.png";